module.exports = __webpack_public_path__ + "static/media/wayside_logo.12788097.png";